import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AddressService } from '../../../shared/services/address.service';
import { TermsConditionsInputComponent } from '../terms-conditions-input/terms-conditions-input.component';
import { SERVICE_PROVIDER } from '../../../shared/services/fee.service';
import { environment } from '../../../../app-environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-terms-conditions-input-2',
  templateUrl: './terms-conditions-input-2.component.html',
  styleUrls: ['./terms-conditions-input-2.component.css']
})
export class TermsConditionsInputComponent2 extends TermsConditionsInputComponent implements OnInit, OnDestroy {

  _termsConditionUrl: string = 'https://gww.com.au/terms-use';

  _pricingZone: string = '';
  _addressSvc?: AddressService;
  _tou_url: string = '';
  _subscriptions: Subscription = new Subscription();

  @Input()
  set termsConditionUrl(url: string) {
    this._termsConditionUrl = url;
    if (!url) {
      this._termsConditionUrl = 'https://gww.com.au/terms-use';
    }
  }

  get termsConditionUrl(): string {
    return this._termsConditionUrl;
  }

  isTermsConditionExternalUrl(): boolean {
    const outsideUrlRegex = new RegExp('^(http|https)://', 'i');
    return outsideUrlRegex.test(this._termsConditionUrl);
  }

  constructor(addressSvc: AddressService) {
    super(addressSvc);
    this._addressSvc = addressSvc;
  }

  ngOnInit() {
    this._subscriptions.add(this._addressSvc.getPricingZone().subscribe((pz: any) => {
      if ((pz || '').toUpperCase() === SERVICE_PROVIDER.WW) {
        this._tou_url = environment.termsOfUseURL.WW;
        this._pricingZone = 'ww';

        this.breachOfInfoTsAndCs = !!this.breachOfInfoTsAndCs;
        this.discretionTsAndCs = !!this.discretionTsAndCs;
      }

      if ((pz || '').toUpperCase() === SERVICE_PROVIDER.CWW) {
        this._tou_url = environment.termsOfUseURL.CWW;
        this._pricingZone = 'cww';

        this.breachOfInfoTsAndCs = null;
        this.discretionTsAndCs = null;
      }
    }));
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  navigateToU() {
    this.agreedToTsAndCs = true;
    window.open(this._tou_url, '_blank');
  }

  get touUrl(): string {
    return this.tou_url;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/terms-conditions-input-2/terms-conditions-input-2.component.ts